<template>
    <div class="proprietary_costs">
      <!--自营仓成本价管理头部-->
      <div class="pc_report_top">
        <div class="sel_input">
          <el-select
            v-model="selectChannelValue"
            collapse-tags
            placeholder="渠道">
            <el-option v-for="item in channelList"
                       :key="item.id"
                       :label="item.text"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="sel_input">
          <el-select v-model="selectBrandType" placeholder="品牌">
            <el-option
              v-for="item in brandTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <input type="text" v-model="goodsNum" maxlength="30" placeholder="货号">
        <input type="text" v-model="goodsName" maxlength="60" placeholder="品名">

        <button class="btn btn_normal ml10" @click="getSelftStoreCostPageList()">查询</button>

        <button class="btn btn_normal fr mr10 pl10 pr10" @click="importFile()">更新货品成本</button>
        <button class="btn btn_normal fr mr10 pl10 pr10" @click="getSelfCostImportExcelTemplet()">导出模板</button>
        <button class="btn btn_normal fr mr10 pl10 pr10" @click="exportSelfCostExcel()">导出查询结果</button>
      </div>
      <!--自营仓成本价内容-->
      <div class="pc_report_msg">
        <div class="pc_report_msg_content mb20" v-for="(item, index) in list" :key="index">
          <div class="mt15 mb10">
            <label>货号:</label>
            <span>{{item.GoodsId}}</span>
            <label>品名:</label>
            <span>{{item.GoodsName}}</span>
            <label>吊牌价:</label>
            <span>{{item.MarketPrice}}</span>
            <label>性别:</label>
            <span>{{item.GenderName}}</span>
            <label>颜色:</label>
            <span>{{item.GoodsColorName}}</span>
            <label>品牌:</label>
            <span>{{item.BrandName}}</span>
            <label>分类:</label>
            <span>{{item.ClassName}}</span>
            <label>发布季节:</label>
            <span>{{item.MarketSeasoin}}</span>
          </div>

          <div>
            <table class="table">
              <thead>
              <tr>
                <th>仓库</th>
                <th v-for="(sizeItem) in item.BaseSizeList">
                  <p>{{sizeItem.Size}}</p>
                </th>
                <th>合计</th>
                <th>代理价(元)</th>
                <th>代理折扣</th>
                <th>成本价(元)</th>
                <th>成本折扣</th>
                <th>成本总金额(元)</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(channelItem, channelIndex) in item.channel">
                <td>{{channelItem.StoreroomName}}</td>
                <td v-for="(sizeMsgItem, sizeIndex) in channelItem.sizeMsgList">{{sizeMsgItem.stock}}</td>
                <td>{{channelItem.stockTotal}}</td>
                <td>{{channelItem.SupplyPrice}}</td>
                <td>{{channelItem.SupplyDiscount}}</td>
                <td>{{channelItem.CostPrice}}</td>
                <td><input class="w50" type="number" min='0.000' step='0.001' v-model="channelItem.CostDiscount"
                           @blur="editCostDiscout(item.GoodsId, channelItem.StoreroomId, channelItem.CostDiscount)"></td>
                <td>{{channelItem.AllCostAmount}}</td>
                <td><a @click="showLog(item.GoodsId, channelItem.StoreroomId)">日志</a></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--分页-->
        <div class="text_right mt20" v-if="list">
          <el-pagination
            background
            :prev-text="'上一页'"
            :next-text="'下一页'"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total">
          </el-pagination>
      </div>
      </div>

      <!--弹出框-->
      <proprietary-costs-embed-msg v-if="isShow"
                                   :title="dialogTitle"
                                   :showType="dialogShowType"
                                   :msg="dialogMsg" @cancelbtn="getSelectDialogEmbed"></proprietary-costs-embed-msg>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>

    </div>
</template>

<script>
  import ProprietaryCostsEmbedMsg from './proprietary-costs-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'proprietary-cots',
    components: {ProprietaryCostsEmbedMsg, LoadingDialog, MsgDialog},
    data() {
      return {
        list: null, // 列表
        channelList: [], // 渠道下拉列表
        selectChannelValue: '', // 选择的渠道列表
        brandTypeList: [], // 查询品牌下拉列表
        selectBrandType: '', // 选择到的查询品牌类型
        goodsNum: null, // 货号
        goodsName: null, // 品名
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        dialogMsg: null, // 弹出框输入内容
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isTip: false, // 提示框显示
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取渠道下拉框信息
      getSelftStoreroomIdByClientId() {
        this.$axios.post(this.Global.getSelftStoreroomIdByClientId, null).then((res) => {
          if (res.data) {
            if (!res.data.errorMsg.length) {
              this.channelList = res.data.resData;
              this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
              this.selectChannelValue = '';
            } else {
              this.channelList = [];
              this.selectChannelValue = res.data.errorMsg;
            }
          }
        });
      },

      // 加载品牌下拉数据
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.brandTypeList = res.data.resData;
            this.brandTypeList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrandType = '';
          } else {
            this.brandTypeList = [];
            this.selectBrandType = res.data.errorMsg;
          }
        });
      },

      // 自营仓真实货品成本分页数据
      getSelftStoreCostPageList() {
        this.isLoading = true;
        const params = {
          StoreroomId: this.selectChannelValue,
          GoodsId: this.goodsNum,
          BrandId: this.selectBrandType,
          GoodsTitile: this.goodsName,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getSelftStoreCostPageList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                for (let i = 0; i < self.list.length; i++) {
                  self.$set(self.list[i], 'channel', []); // 渠道信息集合数组
                  self.$set(self.list[i], 'sizeStockTotal', 0); // 总库存合计
                  self.$set(self.list[i], 'sizeStockList', []); // 各尺码库存合计
                  self.list[i].channel = self.list[i].BaseStoreroomList;

                  for (let j = 0; j < self.list[i].BaseStoreroomList.length; j++) {
                    self.$set(self.list[i].channel[j], 'sizeMsgList', []);
                    self.$set(self.list[i].channel[j], 'stockTotal', 0);

                    // 遍历尺码
                    for (let k = 0; k < self.list[i].BaseSizeList.length; k++) {
                      // 添加渠道尺码
                      self.list[i].channel[j].sizeMsgList.push({
                        size: self.list[i].BaseSizeList[k].Size,
                        sizeId: self.list[i].BaseSizeList[k].SizeId,
                        skuId: null,
                        stock: 0,
                        orderNum: 0
                      });

                      // 遍历库存
                      for (let g = 0; g < self.list[i].StockList.length; g++) {
                        if ((self.list[i].channel[j].StoreroomId === self.list[i].StockList[g].StoreroomId) && (self.list[i].channel[j].sizeMsgList[k].size === self.list[i].StockList[g].Size)) {
                          self.list[i].channel[j].sizeMsgList[k].skuId = self.list[i].StockList[g].SkuId;
                          self.list[i].channel[j].sizeMsgList[k].stock = self.list[i].StockList[g].Stock;
                          // self.list[i].channel[j].sizeMsgList[k].CostDiscount = self.list[i].StockList[g].CostDiscount;
                          // self.list[i].channel[j].sizeMsgList[k].CostPrice = self.list[i].StockList[g].CostPrice;
                          // self.list[i].channel[j].sizeStockList[k] = self.Global.addition(self.list[i].channel[j].sizeStockList[k], self.list[i].channel[j].sizeMsgList[k].stock);
                        }
                      }

                      self.list[i].channel[j].stockTotal = self.list[i].channel[j].stockTotal + self.list[i].channel[j].sizeMsgList[k].stock;
                    }
                  }

                  /* 各个尺码对应的总库存 */
                  for (let k = 0; k < self.list[i].BaseSizeList.length; k++) {
                    self.list[i].sizeStockList.push({size: self.list[i].BaseSizeList[k].Size, stock: 0});
                    for (let g = 0; g < self.list[i].channel.length; g++) {
                      for (let h = 0; h < self.list[i].channel[g].sizeMsgList.length; h++) {
                        if (self.list[i].BaseSizeList[k].Size === self.list[i].channel[g].sizeMsgList[h].size) {
                          self.list[i].sizeStockList[k].stock = self.list[i].sizeStockList[k].stock + self.list[i].channel[g].sizeMsgList[h].stock;
                        }
                      }
                    }
                  }

                  for (let k = 0; k < self.list[i].sizeStockList.length; k++) {
                    self.list[i].sizeStockTotal = self.list[i].sizeStockTotal + self.list[i].sizeStockList[k].stock;
                  }
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          });
        });
      },

      // 导出自营仓成本
      exportSelfCostExcel() {
        this.isLoading = true;
        const params = {
          StoreroomId: this.selectChannelValue,
          GoodsId: this.goodsNum,
          BrandId: this.selectBrandType,
          GoodsTitile: this.goodsName,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.exportSelfCostExcel, params).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                window.open(res.data.resData, '_blank')
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100);
        });
      },

      // 修改自营仓成本
      editCostDiscout(goodsId, storeroomId, costDiscount) {
        costDiscount = costDiscount.toString();
        const pointIndex = costDiscount.indexOf('.');
        if(pointIndex>0 && (costDiscount.length - pointIndex - 1)>3){
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '只能输入保留三位小数的数字';
          return
        }
        this.$axios.post(this.Global.editCostDiscout(goodsId, storeroomId, costDiscount), null).then((res) => {
          if (res.data) {
            this.isLoading = false;
            if (!res.data.errorMsg.length) {
              this.isMsg = true;
              this.isSuc = true;
              this.txtMsg = '操作成功';
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          }
        });
      },

      // 获取自营仓货品导入模板
      getSelfCostImportExcelTemplet() {
        this.isLoading = true;
        this.$axios.post(this.Global.getSelfCostImportExcelTemplet, null).then((res) => {
          if (res.data) {
            this.isLoading = false;
            if (!res.data.errorMsg.length) {
              window.open(res.data.resData, '_blank');
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          }
        });
      },

      // 导入自营仓货品Excel【仅支持文件放在FormData方式上传】
      importFile() {
        this.isShow = true;
        this.dialogTitle = '上传文件';
        this.dialogShowType = 'import';
      },

      // 日志
      showLog(goodsNum, storeroomId) {
        this.isShow = true;
        this.dialogTitle = '日志';
        this.dialogShowType = 'log';
        this.dialogMsg = {
          goodsNum: goodsNum,
          storeroomId: storeroomId
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.getSelftStoreCostPageList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getSelftStoreCostPageList();
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType === true) {
          if (this.selectChannelValue || this.goodsNum || this.goodsName) {
            this.getSelftStoreCostPageList();
          }
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getSelftStoreroomIdByClientId();
      this.getAllBrandsList();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .proprietary_costs {
    background-color: #ffffff;
    height: 100%;
    position: relative;

    .pl10 {
      padding-left: 10px;
    }

    .pr10 {
      padding-right: 10px;
    }

    .pc_report_top{
      padding-top: 10px;
      margin-bottom: 10px;

      input[type='text'], .sel_input {
        display: inline-block;
        width: 130px;
        margin-left: 5px;
      }
    }

    .pc_report_msg{
      height: calc(100% - 118px);
      margin-left: 10px;
      margin-right: 10px;
      border: 1px solid #eee;
      padding: 10px 5px;
      overflow: auto;

      .pc_report_msg_content {
        label {
          font-weight: bold;
        }

        span {
          color: #ff0000;
          margin-right: 5px;
        }

        th, td {
          border-right: 1px solid #ddd;
        }

        a {
          color: #169BD5;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/report-management/proprietary-costs.vue